<template>
  <div class="buyOrderParticulars">
        <van-nav-bar
            title="买料详情"
            left-arrow
            fixed
            safe-area-inset-top
            placeholder 
            @click-left="leftClick"
        />
        <!-- 审核进度    待审核-->
        <div class="reviewProgress  ToBeReviewed" v-if="orderList.status == 'SUSPENSE'">
                <div class="progress">
                    <div class="icons">
                       <div class="iconText">   
                             <div class="icon ione"></div>   
                             <div class="bottomText">提交订单</div>    
                        </div>

                             <div class="iconLine ilone"></div>
                       <div class="iconText">   
                             <div class="icon itwo"></div>
                             <div class="bottomText">平台审核</div>   
                       </div>
                              <div class="iconLine iltwo"></div>
                       <div class="iconText">  
                              <div class="icon ithree"></div>
                              <div class="bottomText">提料</div>    
                        </div> 
                              <div class="iconLine iltwo"></div>
                       <div class="iconText">  
                              <div class="icon ifour"></div>   
                              <div class="bottomText">交易完成</div>    
                       </div>
                    </div>

                </div>
        </div>      
        <!-- 审核进度  未通过  取料审核中   待取料-->
        <div class="reviewProgress  FailAndReclaiming" v-if="orderList.status == 'WAIT_FETCH_AUDIT' || orderList.status == 'WAIT_FETCH' || orderList.status == 'FAIL'">
                <div class="progress">
                    <div class="icons">
                       <div class="iconText">   
                             <div class="icon ione"></div>   
                             <div class="bottomText">提交订单</div>    
                        </div>

                             <div class="iconLine ilone"></div>
                       <div class="iconText">   
                             <div class="icon itwo"></div>
                             <div class="bottomText">平台审核</div>   
                       </div>
                              <div class="iconLine iltwo"></div>
                       <div class="iconText">  
                              <div class="icon ithree"></div>
                              <div class="bottomText">提料</div>    
                        </div> 
                              <div class="iconLine iltwo"></div>
                       <div class="iconText">  
                              <div class="icon ifour"></div>   
                              <div class="bottomText">交易完成</div>    
                       </div>
                    </div>

                </div>
        </div>      
        <!-- 审核进度  取料中-->
        <div class="reviewProgress reclaiming"  v-if="orderList.status == 'WAIT_FETCH_FINISHED'">
                <div class="progress">
                    <div class="icons">
                       <div class="iconText">   
                             <div class="icon ione"></div>   
                             <div class="bottomText">提交订单</div>    
                        </div>

                             <div class="iconLine ilone"></div>
                       <div class="iconText">   
                             <div class="icon itwo"></div>
                             <div class="bottomText">平台审核</div>   
                       </div>
                              <div class="iconLine iltwo"></div>
                       <div class="iconText">  
                              <div class="icon ithree"></div>
                              <div class="bottomText">提料</div>    
                        </div> 
                              <div class="iconLine iltwo"></div>
                       <div class="iconText">  
                              <div class="icon ifour"></div>   
                              <div class="bottomText">交易完成</div>    
                       </div>
                    </div>

                </div>
        </div>      
        <!-- 审核进度  已完成-->
        <div class="reviewProgress  Completed" v-if="orderList.status == 'DONE'">
                <div class="progress">
                    <div class="icons">
                       <div class="iconText">   
                             <div class="icon ione"></div>   
                             <div class="bottomText">提交订单</div>    
                        </div>

                             <div class="iconLine ilone"></div>
                       <div class="iconText">   
                             <div class="icon itwo"></div>
                             <div class="bottomText">平台审核</div>   
                       </div>
                              <div class="iconLine iltwo"></div>
                       <div class="iconText">  
                              <div class="icon ithree"></div>
                              <div class="bottomText">提料</div>    
                        </div> 
                              <div class="iconLine iltwo"></div>
                       <div class="iconText">  
                              <div class="icon ifour"></div>   
                              <div class="bottomText">交易完成</div>    
                       </div>
                    </div>

                </div>
        </div>     

        <!-- 订单信息 -->
        <div class="orderInfo">
            <div class="orderTop title">
                <h3> <div class="line"></div>  订单信息</h3>
                <h3 :style="{color:orderList.status == 'FAIL'?'red':'#1a1a1a'}">{{orderList.status == 'WAIT_FETCH_AUDIT'?'取料审核中...'
                    :orderList.status == 'WAIT_FETCH'?'待取料'
                    :orderList.status == 'FAIL'?'未通过'
                    :orderList.status == 'SUSPENSE'?'待审核'
                    :orderList.status == 'WAIT_FETCH_FINISHED'?'取料中'
                    :'已完成'}}</h3>
            </div>
            <div class="info">
                                    <!-- 下单时间 -->
                    <div class="flex">
                        <div class="leftText">下单时间:</div>
                        <div class="rightText">{{orderList.createTime | formatDate_}}</div>
                    </div>        
                                    <!-- 订单编号 -->
                    <div class="flex">
                        <div class="leftText">订单编号:</div>
                        <div class="rightText">{{orderList.oid}}</div>
                    </div>
                                    <!-- 货物分类 -->
                    <div class="flex">
                        <div class="leftText">货物分类:</div>
                        <div class="rightText">{{orderList.goods[0].name}}</div>
                    </div>
                                    <!-- 单价 -->
                    <div class="flex">
                        <div class="leftText">单价(元/克):</div>
                        <div class="rightText">{{orderList.goods[0].price}}</div>
                    </div>
                                    <!-- 重量 -->
                    <div class="flex">
                        <div class="leftText">重量(克):</div>
                        <div class="rightText">{{orderList.goods[0].weight.toFixed(2)}}</div>
                    </div>
                                    <!-- 金额 -->
                    <div class="flex">
                        <div class="leftText">金额(元):</div>
                        <div class="rightText">{{orderList.goods[0].total}}</div>
                    </div>
            </div>
        </div>

        <!-- 收款账号 -->
        <div class="getMoney" v-if="orderList.status == 'FAIL' ||orderList.status == 'DONE'?false:true">
            <div class="title">
                <h3> <div class="line"></div>  中鑫金收款账号</h3>
                <div class="copy" @click="copy(banklist.bankCard.num)">复制</div>
            </div>
            <div class="info">
                        <!-- 银行图标 -->
                <div class="bankIcon">
                    <img v-if="banklist.id == 10" :src="banklist.bankCard.logo" class="Img" alt="">
                    <div v-if="!banklist.id == 10" class="icon"></div>
                    <div class="bank">{{banklist.bankCard.bank}}</div>
                </div>
               <div class="moneyflex">
                        <div class="leftText">银行卡号:</div>
                        <div class="rightText">{{banklist.bankCard.num}}</div>
                </div>
                <div class="moneyflex">
                        <div class="leftText">开户支行:</div>
                        <div class="rightText">{{banklist.bankCard.address}}</div>
                </div> 
                <div class="moneyflex">
                        <div class="leftText">持卡人:</div>
                        <div class="rightText">{{banklist.bankCard.name}}</div>
                </div>  
            </div>
        </div>
        <!-- 结算单 -->
        <div class="settlementSheet">
                <h3 class="jieSuan">结算单</h3>
                <div class="xiangQing" @click="ToPurchaseSettlement">
                    <div class="leftIcon"></div>
                    <div class="rightIcon"></div>
                </div>
        </div>
  </div>
</template>

<script>
import *as api from'@/utils/api'
export default {
        data() {
            return {
                // 系统银行卡信息
                banklist:[],
                // 订单信息
                orderList:[],
                // 订单编号
                order:this.$route.query.order,
            }
        },
        methods:{
            // 跳转结算详情页面
            ToPurchaseSettlement(){
                    this.$router.push({
                        name:'purchaseSettlement',
                        query:{openId:this.orderList.openId}
                    })
            },
              // 封装获取系统银行卡的信息
            async getBankList(){
                let res = await api.banklist()
                // 获取id为10的银行类型
                res.forEach((item)=>{
                    if (item.id == 10) {
                        this.banklist = item
                    }
                    
                })

                console.log(this.banklist);
            },
              // 顶部左侧按钮点击事件
            leftClick(){
                this.$router.back()
            },
            //  复制功能
            copy(txt){
                this.$copyText(txt).then(()=>{
                this.$toast('卡号已复制到剪贴板')
            })
        },
        },
async  created(){
            //调用方法获取系统银行卡的信息
            this.getBankList()
            let res = await  api.getbuygold(this.order)
            this.orderList = res
            console.log('1',res);
        }
}
</script>

<style lang="scss" scoped>
::v-deep{
     .van-nav-bar{
        height: 100px;
        .van-nav-bar__content{
        line-height: 100px;
        height: 100px;
        .van-nav-bar__title{
            font-size: 40px;
        }
        .van-icon{
            font-size: 40px;
            color: #1e1e1e;
        }
        }
     }
}
.buyOrderParticulars{
    background-color: #f5f5f5;
    height: 100%;
    width: 100%;
    .reviewProgress{
        width: 100%;
        height: 135px;
        background-color: #fff;
        padding:20px 80px 0 80px;
        .progress{
            width: 100%;
            .icons{
                width: 100%;
                display: flex;
                .iconText{
                    width: 200px;
                    height: 100%;
                    .icon{
                         width: 68px;
                         height: 64px;
                         margin-left: 20px;

                    }
                    .bottomText{
                        text-align: center ; 
                    }
                }
            .iconLine{
                width:80px;
                height: 14px;
                margin-top: 28px;
                    }
            .ilone{
                background: url("~@/assets/images/arrow 1@2x.png") no-repeat;
                background-size: 100% 100%;
            }
            .iltwo{
                background: url("~@/assets/images/arrow 2@2x.png") no-repeat;
                background-size: 100% 100%;
            }
            }
        }
    }
    .ToBeReviewed{
             .ione{
                 background: url("~@/assets/images/order@2x.png") no-repeat;
                 background-size: 100% 100%;
             }
             .itwo{
                 background: url("~@/assets/images/audit2@2x.png") no-repeat;
                 background-size: 100% 100%;
             }
             .ithree{
                 background: url("~@/assets/images/submit@2x.png") no-repeat;
                 background-size: 100% 100%;
             }
             .ifour{
                 background: url("~@/assets/images/complete@2x.png") no-repeat;
                 background-size: 100% 100%;
             }
    }
    .FailAndReclaiming{
             .ione{
                 background: url("~@/assets/images/order@2x.png") no-repeat;
                 background-size: 100% 100%;
             }
             .itwo{
                 background: url("~@/assets/images/audit@2x.png") no-repeat;
                 background-size: 100% 100%;
             }
             .ithree{
                 background: url("~@/assets/images/submit@2x.png") no-repeat;
                 background-size: 100% 100%;
             }
             .ifour{
                 background: url("~@/assets/images/complete@2x.png") no-repeat;
                 background-size: 100% 100%;
             }
    }
    .reclaiming{
             .ione{
                 background: url("~@/assets/images/order@2x.png") no-repeat;
                 background-size: 100% 100%;
             }
             .itwo{
                 background: url("~@/assets/images/audit@2x.png") no-repeat;
                 background-size: 100% 100%;
             }
             .ithree{
                 background: url("~@/assets/images/submit2@2x.png") no-repeat;
                 background-size: 100% 100%;
             }
             .ifour{
                 background: url("~@/assets/images/complete@2x.png") no-repeat;
                 background-size: 100% 100%;
             }
    }    
    .Completed{
             .ione{
                 background: url("~@/assets/images/order@2x.png") no-repeat;
                 background-size: 100% 100%;
             }
             .itwo{
                 background: url("~@/assets/images/audit@2x.png") no-repeat;
                 background-size: 100% 100%;
             }
             .ithree{
                 background: url("~@/assets/images/submit2@2x.png") no-repeat;
                 background-size: 100% 100%;
             }
             .ifour{
                 background: url("~@/assets/images/complete2@2x.png") no-repeat;
                 background-size: 100% 100%;
             }
    }
    .orderInfo{
            width: 100%;
            background-color: #fff;
            margin-top: 30px;
            padding: 20px 0;
            .orderTop{
                border-bottom: 1px solid #CCCCCC;
                padding: 0 28px 20px;
                display: flex;
                justify-content: space-between;
                .line{
                    width: 6px;
                    height: 100%;
                    background-color: #ffb606;
                    position: absolute;
                    top: 0;
                    left:-10px
                }
                h3{
                    position: relative;
                    font-size: 32px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #1A1A1A;
                    display: flex;
                }
            }
            .info{
                padding: 20px 28px;
            }
    }
    .getMoney{
            width: 100%;
            background-color: #fff;
            margin-top: 40px;
            padding: 20px 0;
            .info{
                padding: 20px 28px;
                .bankIcon{
                    width: 100%;
                    display: flex;
                    .Img{
                        width: 48px;
                        height: 48px;
                    }
                    .icon{
                        width: 48px;
                        height: 48px;
                        background: url("~@/assets/images/icon_shou@2x.png") no-repeat;
                        background-size: 100% 100%;
                    }
                    .bank{
                        line-height: 48px;
                        margin-left: 20px;
                    }
                }
            }
    }
    .settlementSheet{
        width: 100%;
        background-color: #fff;
        padding: 20px 28px;
        margin-top: 40px;
        display: flex;
        justify-content: space-between;
        .jieSuan{
            font-size: 32px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #1A1A1A;
            display: flex;
        }
        .xiangQing{
            width: 110px;
            height: 32px;
            display: flex;
            justify-content: space-between;
            position: relative;
            .leftIcon{
                position: absolute;
                bottom: 0;
                width: 78px;
                height: 34px;
                background: url("~@/assets/images/详情@2x.png") no-repeat;
                background-size: 84% 100%;
            }
            .rightIcon{
                position: absolute;
                bottom: -4px;
                right: 0;
                width: 40px;
                height: 32px;
                background: url("~@/assets/images/＞@2x.png") no-repeat;
                background-size: 84% 86%;
            }
        }
    }
}
.flex{
    display: flex;
    justify-content: space-between;
    .leftText{
        font-size: 28px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #CCCCCC;
        line-height: 55px;
    }
    .rightText{
        font-size: 28px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #1A1A1A;
        line-height: 55px;
    }
}
.moneyflex{
     display: flex !important;
     .leftText{
        font-size: 28px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #CCCCCC;
        line-height: 55px;
        text-align: left;
        margin-right:18px;
        width: 150px;
    }
    .rightText{
        font-size: 28px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #1A1A1A;
        line-height: 55px;
        text-align: left;
    }
}
.title{
                border-bottom: 1px solid #CCCCCC;
                padding: 0 28px 20px;
                display: flex;
                justify-content: space-between;
                .line{
                    width: 6px;
                    height: 100%;
                    background-color: #ffb606;
                    position: absolute;
                    top: 0;
                    left:-10px
                }
                h3{
                    font-size: 32px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #1A1A1A;
                    display: flex;
                    position: relative;
                }
}
.copy{
    color: #ffb606;
}
</style>